export const useValuationService =
  process.env.NEXT_PUBLIC_VALUATION_SERVICE === 'ON';

export const useMaintenanceMode =
  process.env.NEXT_PUBLIC_MAINTENANCE_MODE === 'ON';
